"use strict";
(function (global) {

  /**
   * Создать новую строку детального раздела.
   *
   * @function WebAccess.services.cardform.createTableRow
   * @param {Link} obj Ссылка на объект
   * @param {string} view Представление, в котором открыта карточка
   * @param {integer} detailNum Номер детального раздела
   * @param {string} tableName Имя таблицы детального раздела
   * @param {integer} number Номер строки таблицы

   * @return {Deferred} Специальный deferred-объект.
   */
  global.cardform.createTableRow = function (obj, requisites, view, detailNum, tableName, number, opt_sync) {
    var callFunc = (opt_sync === true) ? global.callSync : global.call;
    return callFunc("/CardForm.asmx/CreateTableRow", {
      Obj: obj,
      Requisites: requisites || {},
      View: view,
      DetailNum: detailNum,
      Number: number
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Копирует строку детального раздела.
  *
  * @function WebAccess.services.cardform.copyTableRow
  * @param {Link} obj Ссылка на объект
  * @param {string} view Представление, в котором открыта карточка
  * @param {integer} detailNum Номер детального раздела
  * @param {integer} sourceRowID ИД копириуемой строки
  * @param {string} tableName Имя таблицы детального раздела
  * @param {integer} number Номер строки таблицы
  * @return {Deferred} Специальный deferred-объект.
  * @since 5.2.0.1300
  */
  global.cardform.copyTableRow = function (obj, requisites, view, detailNum, sourceRowID, tableName, number, opt_sync) {
    var callFunc = (opt_sync === true) ? global.callSync : global.call;
    return callFunc("/CardForm.asmx/CopyTableRow", {
      Obj: obj,
      View: view,
      DetailNum: detailNum,
      SourceRowID: sourceRowID,
      Number: number,
      Requisites: requisites || {}
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//



  /**
   * Удалить строку детального раздела по ИД.
   *
   * @function WebAccess.services.cardform.deleteTableRow
   * @param {Link} obj Ссылка на объект
   * @param {string} view Представление, в котором открыта карточка
   * @param {integer} detailNum Номер детального раздела
   * @param {integer} rowID ИД строки таблицы
   * @return {Deferred} Специальный deferred-объект.
   * @since 5.2.0.1300
   */
  global.cardform.deleteTableRow = function (obj, view, detailNum, rowID, opt_sync) {
    var callFunc = (opt_sync === true) ? global.callSync : global.call;
    return callFunc("/CardForm.asmx/DeleteTableRow", {
      Obj: obj,
      View: view,
      DetailNum: detailNum,
      RowID: rowID
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Сохранить карточку объекта.
 *
 * @function WebAccess.services.cardform.save
 * @param {Link} obj Ссылка на объект
 * @param {string} view Представление, в котором открыта карточка
 * @param {Object} reqs Значения реквизитов
 * @param {Object} cmd Дополнительные команды при сохранении. Например, удаление строки детального раздела
 * @param {boolean} needSaveObject Признак необходимости сохранения карточки
 * @param {integer} folderIdToPaste ИД папки, в которую вставлена ссылка
 *
 * @return {Deferred} Специальный deferred-объект.
 */
  global.cardform.save = function (obj, view, reqs, cmd, needSaveObject, folderIdToPaste) {
    return global.call("/CardForm.asmx/Save", {
      Obj: obj,
      View: view,
      Req: reqs,
      Cmd: cmd,
      NeedSaveObject: needSaveObject,
      FolderIDToPaste: folderIdToPaste
    }, false, false, true, true);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Сохранение карточки объекта и вставка этого объект в папку или ЗЗУ.
 * @param {Link} obj Ссылка на объект.
 * @param {string} view Представление, в котором открыта карточка.
 * @param {Object} reqs Значения реквизитов.
 * @param {Object} cmd Дополнительные команды при сохранении (например, удаление строки детального раздела(.
 * @param {boolean} needSaveObject Признак нужно ли сохранять карточку.
 * @param {Link} receiverObjectLink Ссылка куда надо вставить объект после сохранения.
 * @function WebAccess.services.cardform.saveAndAttach
 * @return {Deferred} jQuery Deferred объект
 */
  global.cardform.saveAndAttach = function (obj, view, reqs, cmd, needSaveObject, receiverObjectLink) {
    return global.call("/CardForm.asmx/SaveAndAttach", {
      Obj: obj,
      View: view,
      Req: reqs,
      Cmd: cmd,
      NeedSaveObject: needSaveObject,
      ReceiverObjectLink: (!!receiverObjectLink && receiverObjectLink.id ? receiverObjectLink.toLinkModel() : null)
    }, false, false, true, true);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess.services);
